<template>
  <el-dialog
    v-model="dialogVisible"
    width="1000px"
    :before-close="handleClose"
    :append-to-body="true"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    :show-close="true"
    custom-class="material-detail-dialog"
    :modal-class="'material-detail-modal'"
    :lock-scroll="true"
  >
    <div class="material-detail">
      <!-- 标题区域 -->
      <div class="header-section">
        <h2>{{ material?.title }}</h2>
      </div>

      <!-- 预览图 -->
      <div class="preview-section">
        <el-image
          :src="material?.preview_url"
          fit="contain"
          class="preview-image"
          @click="handlePreviewClick"
        />
        <!-- 导航按钮 -->
        <div class="nav-buttons" v-if="hasSiblings">
          <el-button 
            class="nav-button prev" 
            :icon="ArrowLeft"
            circle
            @click="handlePrevious"
            v-show="hasPrevious"
          />
          <el-button 
            class="nav-button next" 
            :icon="ArrowRight"
            circle
            @click="handleNext"
            v-show="hasNext"
          />
        </div>
      </div>

      <!-- 底部信息栏 -->
      <div class="footer-section">
        <!-- 左侧信息 -->
        <div class="info-left">
          <div class="category">分类：{{ material?.category_name }}</div>
          <div class="publish-time">添加时间：{{ formatDate(material?.upload_time || material?.created_at) }}</div>
        </div>

        <!-- 右侧下载按钮组 -->
        <div class="download-buttons">
          <el-button 
            type="primary" 
            :icon="Download"
            @click="handleDownloadV2('preview')"
            :disabled="checkvip()"
          >预览图下载</el-button>
          <el-button 
            type="primary" 
            :icon="Download"
            @click="handleDownloadV2('fla')"
            :disabled="!material?.fla_file || checkvip()"
          >FLA文件下载</el-button>
          <el-button 
            type="primary" 
            :icon="Download"
            @click="handleDownloadV2('psd')"
            :disabled="!material?.psd_file || checkvip()"
          >PSD文件下载</el-button>
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- 全屏预览组件 -->
  <el-image-viewer
    v-if="showViewer"
    :url-list="[material?.preview_url || '']"
    :initial-index="0"
    @close="showViewer = false"
  />
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { Download, ArrowLeft, ArrowRight } from '@element-plus/icons-vue';
import { MaterialService } from '@/api/material';
import request from "@/api/request.ts";
import requestV2 from '@/utils/requestV2';


const props = defineProps<{
  visible: boolean
  material: any | null
  allMaterials?: any[] // 所有素材列表
  currentIndex?: number // 当前素材索引
}>();

const emit = defineEmits(['update:visible', 'view', 'change', 'update']);

const dialogVisible = ref(props.visible);
const showViewer = ref(false);

// 计算是否有相邻素材
const hasSiblings = computed(() => props.allMaterials && props.allMaterials.length > 1);
const hasPrevious = computed(() => props.currentIndex !== undefined && props.currentIndex > 0);
const hasNext = computed(() => {
  return props.currentIndex !== undefined && 
         props.allMaterials && 
         props.currentIndex < props.allMaterials.length - 1;
});

// 监听visible属性变化
watch(() => props.visible, (val) => {
  dialogVisible.value = val;
});

watch(() => dialogVisible.value, (val) => {
  emit('update:visible', val);
  if (val && props.material) {
    emit('view', props.material.id);
  }
});

// 格式化日期
const formatDate = (dateStr: string) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }) + ' ' + date.toLocaleTimeString('zh-CN', {
    hour: '2-digit',
    minute: '2-digit'
  });
};

// 格式化日期
const checkvip = () => {
  console.log('checkvip');
  // debugger;
  const user = JSON.parse(localStorage.getItem('user'));
  console.log(user);
  if (user && user.vip_level > 0) {
  console.log(user);
    return false;
  }
  return true;
};

// 处理下载
const handleDownload = async (type: string) => {
  if (!props.material) return;
  
  try {
    // 获取下载链接
    const token = localStorage.getItem('token');
    const downloadUrl = `/api/materials/${props.material.id}/download/${type}`;
    
    // 创建一个查询参数，包含token以便验证
    const params = new URLSearchParams();
    if (token) {
      params.append('token', token);
    }
    
    // 显示下载中提示
    ElMessage.info('准备下载文件，请稍候...');
    
    // 构建完整URL
    const fullUrl = `${downloadUrl}?${params.toString()}`;
    
    // 创建隐藏的a标签并模拟点击来触发下载
    const link = document.createElement('a');
    link.href = fullUrl;
    link.style.display = 'none';
    // 设置下载文件名为material.title加上对应扩展名
    document.body.appendChild(link);
    link.click();
    
    // 点击后稍等片刻再删除元素
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
    }, 100);
    
    // 异步更新素材的下载计数
    setTimeout(async () => {
      try {
        const response = await MaterialService.getDetail(props.material.id);
        if (response && response.data) {
          // 触发素材更新事件
          emit('update', response.data);
        }
      } catch (err) {
        console.error('获取更新后的素材信息失败:', err);
      }
    }, 1000); // 延迟1秒执行，给服务器时间更新下载计数
  } catch (error) {
    console.error('下载失败:', error);
    ElMessage.error('下载失败，请重试');
  }
};

// 处理下载
const handleDownloadV2 = async (type: string) => {
  if (!props.material) return;

  try {
    let objectName = props.material.preview_dw_file;
    if (type === "fla") {
      objectName = props.material.fla_file;
    } else if (type === "psd") {
      objectName = props.material.psd_file;
    }

    const res = await requestV2.post('/file/getDownloadUrl', {
      objectName: objectName,
    });

    const fileType = objectName.split(".").pop(); // 更安全的方式获取文件扩展名
    const fullUrl = res.data.data.data.url;
    
    // 使用 fetch 获取文件然后创建对象URL
    const response = await fetch(fullUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = url;
    link.style.display = 'none';
    link.download = `${props.material.title}.${fileType}`;
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
      window.URL.revokeObjectURL(url); // 释放对象URL
    }, 100);

  } catch (error) {
    console.error('下载失败:', error);
    ElMessage.error('下载失败，请重试');
  }
};

// 获取文件扩展名
const getFileExtension = (type: string) => {
  switch (type) {
    case 'preview':
      return '.png';
    case 'fla':
      return '.fla';
    case 'psd':
      return '.psd';
    default:
      return '';
  }
};

// 处理关闭
const handleClose = () => {
  dialogVisible.value = false;
};

// 处理预览点击
const handlePreviewClick = () => {
  showViewer.value = true;
};

// 处理上一个/下一个
const handlePrevious = () => {
  if (props.currentIndex !== undefined && props.currentIndex > 0) {
    emit('change', props.currentIndex - 1);
  }
};

const handleNext = () => {
  if (props.currentIndex !== undefined && props.allMaterials && 
      props.currentIndex < props.allMaterials.length - 1) {
    emit('change', props.currentIndex + 1);
  }
};

// 处理键盘事件
const handleKeydown = (e: KeyboardEvent) => {
  if (!dialogVisible.value) return;
  
  switch (e.key) {
    case 'ArrowLeft':
      if (hasPrevious.value) handlePrevious();
      break;
    case 'ArrowRight':
      if (hasNext.value) handleNext();
      break;
    case 'Escape':
      if (showViewer.value) {
        showViewer.value = false;
      } else {
        handleClose();
      }
      break;
  }
};

// 监听键盘事件
onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});

// 记录素材查看
const recordView = async (materialId: number) => {
  try {
    // 替换为API服务调用
    // await MaterialService.recordView(materialId);
  } catch (error) {
    console.error('记录查看失败', error);
  }
};

// 当用户查看素材时，记录查看状态
const handleView = () => {
  recordView(props.material.id);
  emit('view', props.material);
};

// 当用户打开对话框时，自动记录查看状态
onMounted(() => {
  if (props.visible && props.material) {
    recordView(props.material.id);
  }
});

// 监听对话框可见性变化，当变为可见时记录查看状态
watch(() => props.visible, (newVal) => {
  if (newVal && props.material) {
    recordView(props.material.id);
  }
});

// 监听素材变化，当查看新素材时记录状态
watch(() => props.material, (newMaterial) => {
  if (props.visible && newMaterial) {
    recordView(newMaterial.id);
  }
}, { deep: true });
</script>

<style scoped>
.material-detail-dialog {
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.material-detail {
  display: flex;
  flex-direction: column;
  min-height: 600px;
  background: #fff;
}

.header-section {
  padding: 8px 20px;
  border-bottom: 1px solid #eee;
}

.header-section h2 {
  margin: 0;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
}

.preview-section {
  flex: 1;
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
  padding: 20px;
  position: relative;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.preview-image:hover {
  transform: scale(1.02);
}

.footer-section {
  padding: 24px 32px;
  background: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
}

.info-left {
  color: #666;
}

.category {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}

.publish-time {
  font-size: 14px;
  color: #999;
}

.download-buttons {
  display: flex;
  gap: 12px;
}

.el-button {
  border-radius: 6px;
  padding: 10px 20px;
  transition: all 0.3s ease;
}

.el-button:not([disabled]):hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.el-button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 对话框动画 */
:deep(.el-dialog) {
  transform: scale(0.9);
  opacity: 0;
  transition: all 0.3s ease-out;
}

:deep(.el-dialog.el-dialog--center) {
  transform: scale(1);
  opacity: 1;
}

/* 背景模糊 */
:global(.material-detail-modal) {
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.3s ease;
}

/* 隐藏对话框头部 */
:deep(.el-dialog__header) {
  display: none;
}

:deep(.el-dialog__body) {
  padding: 0;
}

/* 图片预览遮罩层 */
:deep(.el-image-viewer__mask) {
  backdrop-filter: blur(20px);
  background: rgba(0, 0, 0, 0.8);
}

:deep(.el-image-viewer__close) {
  color: #fff;
  font-size: 32px;
  transition: all 0.3s ease;
}

:deep(.el-image-viewer__close:hover) {
  transform: rotate(90deg);
  color: #409EFF;
}

/* 导航按钮样式 */
.nav-buttons {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  pointer-events: none;
}

.nav-button {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  transition: all 0.3s ease;
}

.nav-button:hover {
  background: #fff;
  transform: scale(1.1);
}
</style>